import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-error-message',
    template: `
  @if (control && control.invalid && control.touched) {
    <div>
      <span class="text_danger_show_acc" >
        {{'common.form_field_required'|cxTranslate}}
      </span>
    </div>
  }`,
    styleUrls: ['./kbBrakeApllicationForms-module.component.scss'],
    standalone: false
})
export class KbErrorMessageComponent {
    @Input() control: AbstractControl;


}
